import React, { Fragment } from 'react';
import styled from 'styled-components';
import { withLocalePrefix } from 'shared/utils/translation';
import EmptyState from '../shared/empty_state';
import Loading from '../shared/loading';
import Names from '../shared/names';

const t = withLocalePrefix('gdpr.data_rules_shared.view.table.rule');

const flattenOffices = (offices) =>
  offices.flatMap(({ children = [], ...office }) => {
    if (children.length) {
      return flattenOffices(children).concat(office);
    }
    return office;
  });

export default function OfficesField(props) {
  const { rule, offices } = props;
  return (
    <Fragment>
      {rule.all_offices ? (
        t('all_offices')
      ) : !offices.length ? (
        <Loading />
      ) : !rule.office_ids.length ? (
        <StyledEmptyState emphasize>{t('no_offices')}</StyledEmptyState>
      ) : (
        <Names
          names={flattenOffices(offices).reduce(
            (acc, o) =>
              rule.office_ids.includes(o.id) ? acc.concat(o.text) : acc,
            []
          )}
        />
      )}
    </Fragment>
  );
}

const StyledEmptyState = styled(EmptyState)`
  margin-top: 0px;
`;
